import { getCheckPartApi } from "@/api/feedback";
export async function getCheckPart(_this) {
  const res = await getCheckPartApi({
    data: {
      suspectPartNumber: _this.form.suspectPartNumber,
    },
  });
  if (res.status == 0) {
    _this.form.suspectPartName = res.data.name;
    if (!res.data.name) {
      _this.$DonMessage.warning(`未找到与${_this.form.suspectPartNumber}对应的疑似/祸首件名称`);
    } else {
      _this.$DonMessage.success(`疑似/祸首件名称获取成功`);
    }
  }
}